import { SWRConfig } from "swr";
import Event from "../../containers/Event/Event";

const EventPage = ({ fallback }) => {
  return (
    <SWRConfig value={{ fallback }}>
      <Event />
    </SWRConfig>
  );
};

export async function getStaticProps({ params }) {
  const res = await fetch(process.env.API_URL + "/events/" + params.slug);
  const event = await res.json();
  const res2 = await fetch(process.env.API_URL + "/events");
  const events = await res2.json();

  return {
    props: {
      fallback: {
        [process.env.API_URL + "/events/" + params.slug]: event,
        [process.env.API_URL + "/events"]: events,
      },
    },
  };
}

export async function getStaticPaths() {
  const res = await fetch(process.env.API_URL + "/events");
  const events = await res.json();

  const paths = events.map((event) => ({
    params: { slug: event.slug },
  }));

  return { paths, fallback: "blocking" };
}

export default EventPage;
